import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "ellipsessvg",
  viewBox: "0 0 1792 2402"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { stroke: "currentColor" }, [
      _createElementVNode("path", {
        d: "M1788.5 454c0 123.353-98.76 235.944-260.51 317.904C1366.43 853.766 1142.99 904.5 896 904.5c-246.992 0-470.427-50.734-631.986-132.596C102.259 689.944 3.5 577.353 3.5 454s98.759-235.944 260.514-317.904C425.573 54.234 649.008 3.5 896 3.5c246.99 0 470.43 50.734 631.99 132.596C1689.74 218.056 1788.5 330.647 1788.5 454Z",
        "vector-effect": "non-scaling-stroke"
      }),
      _createElementVNode("path", {
        d: "M1788.5 550c0 123.353-98.76 235.944-260.51 317.904-161.56 81.862-385 132.596-631.99 132.596-246.992 0-470.427-50.734-631.986-132.596C102.259 785.944 3.5 673.353 3.5 550s98.759-235.944 260.514-317.904C425.573 150.234 649.008 99.5 896 99.5c246.99 0 470.43 50.734 631.99 132.596C1689.74 314.056 1788.5 426.647 1788.5 550Z",
        class: "ellipse-2",
        "vector-effect": "non-scaling-stroke"
      }),
      _createElementVNode("path", {
        d: "M1788.5 646c0 123.353-98.76 235.944-260.51 317.904-161.56 81.866-385 132.596-631.99 132.596-246.992 0-470.427-50.73-631.986-132.596C102.259 881.944 3.5 769.353 3.5 646s98.759-235.944 260.514-317.904C425.573 246.234 649.008 195.5 896 195.5c246.99 0 470.43 50.734 631.99 132.596C1689.74 410.056 1788.5 522.647 1788.5 646Z",
        class: "ellipse-3",
        "vector-effect": "non-scaling-stroke"
      })
    ], -1)
  ]))]))
}
export default { render: render }